import { connect } from 'react-redux';
import styled from 'styled-components';

import { VIDEO_FILE_MIME_TYPES } from 'constants/all';

import { getFileExtension } from 'utils/helpers';

import { getActiveFile } from './data/reducer';

const connector = connect((state) => ({
  file: getActiveFile(state),
}));

const Container = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin: 50px 0 0 0;
  padding: 50px;
  background: #222;
  box-shadow: 0 0 30px #ccc;
  height: calc(100% - 50px);
`;

const StyledVideo = styled.video`
  margin: 0 auto;
  display: block;
  max-width: 100%;
  max-height: 100%;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.5);

  :focus {
    outline: none;
  }
`;

const VideoViewer = ({ file }) => {
  const fileExtension = getFileExtension(file?.filename ?? '');
  return (
    <Container data-fs-hide="true">
      <StyledVideo
        controls={true}
        src={file.url}
        type={VIDEO_FILE_MIME_TYPES[fileExtension]}
      >
        <p>Your browser does not support videos.</p>
      </StyledVideo>
    </Container>
  );
};

export default connector(VideoViewer);
